var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { Box, Button, Card, CardContent, Divider, Stack, Typography, Tooltip } from '@mui/material';
import './../../assets/scss/chatbotConfig.scss';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CustomTextarea from '../FormComponents/TextAreaField';
import TextField from '../../components/FormComponents/TextField';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from '../UtilityComponents/ConfirmationAndInformationPoup';
import { convertUTCToLocal } from '../../utils/commonUtilities';
import { useSelector } from 'react-redux';
var ChatbotConfig = function () {
    var _a = useState([]), faqs = _a[0], setFaqs = _a[1];
    var _b = useState([]), displayedFaqs = _b[0], setDisplayedFaqs = _b[1];
    var _c = useState(''), searchQuery = _c[0], setSearchQuery = _c[1];
    var _d = useState(null), selectedFaq = _d[0], setSelectedFaq = _d[1];
    var _e = useState(false), isCreating = _e[0], setIsCreating = _e[1];
    var _f = useState(''), question = _f[0], setQuestion = _f[1];
    var _g = useState(''), answer = _g[0], setAnswer = _g[1];
    var _h = useState(false), openDeleteConfirmation = _h[0], setOpenDeleteConfirmation = _h[1];
    var _j = useState(false), openSuccessPopup = _j[0], setOpenSuccessPopup = _j[1];
    var _k = useState(false), openCancelConfirmation = _k[0], setOpenCancelConfirmation = _k[1];
    var rolePermissions = useSelector(function (store) { var _a; return ((_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.RolePermissions) || []; });
    var permission = rolePermissions.find(function (perm) { return perm.PermissionKey === 'ADMINISTRATOR:GLOBAL_SETTINGS:CHATBOT_FAQS'; });
    var canAdd = (permission === null || permission === void 0 ? void 0 : permission.Add) === 1;
    var canUpdate = (permission === null || permission === void 0 ? void 0 : permission.Update) === 1;
    var canDelete = (permission === null || permission === void 0 ? void 0 : permission.Delete) === 1;
    var fetchFaqs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, apiData, fetchedFaqs, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: api_urls.GET_FAQS,
                            showLoader: true
                        })];
                case 1:
                    response = _b.sent();
                    if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        apiData = response.data.data || [];
                        if (!Array.isArray(apiData)) {
                            apiData = [apiData];
                        }
                        fetchedFaqs = apiData.map(function (item) {
                            return {
                                id: item.DocumentId,
                                question: item.Question,
                                answer: item.Answer,
                                createdTime: convertUTCToLocal(item.CreatedTime),
                                updatedTime: convertUTCToLocal(item.UpdatedTime)
                            };
                        });
                        setFaqs(fetchedFaqs);
                        setDisplayedFaqs(fetchedFaqs);
                        return [2, fetchedFaqs];
                    }
                    return [3, 3];
                case 2:
                    error_1 = _b.sent();
                    return [2, faqs];
                case 3: return [2];
            }
        });
    }); };
    useEffect(function () {
        fetchFaqs();
    }, []);
    var handleSearchInputChange = function (e) {
        var value = e.target.value;
        setSearchQuery(value);
        if (!value.trim()) {
            setDisplayedFaqs(faqs);
        }
        else {
            var filtered = faqs.filter(function (faq) {
                return faq.question.toLowerCase().includes(value.toLowerCase()) ||
                    faq.answer.toLowerCase().includes(value.toLowerCase());
            });
            setDisplayedFaqs(filtered);
            setSelectedFaq(null);
            setIsCreating(false);
        }
    };
    var handleEditFaq = function (faq) {
        setSearchQuery('');
        handleSelectFaq(faq);
    };
    var handleCreateNew = function () {
        setIsCreating(true);
        setSelectedFaq(null);
        setQuestion('');
        setAnswer('');
        setDisplayedFaqs([]);
        setSearchQuery('');
    };
    var handleSelectFaq = function (faq) {
        setSelectedFaq(faq);
        setIsCreating(false);
        setQuestion(faq.question);
        setAnswer(faq.answer);
    };
    var handleCancel = function (isFromButton) {
        setSelectedFaq(null);
        setIsCreating(false);
        setQuestion('');
        setAnswer('');
        setSearchQuery('');
        if (isFromButton) {
            setDisplayedFaqs(faqs);
        }
        else {
            fetchFaqs();
        }
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, payload, response, error_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 5, , 6]);
                    if (!isCreating) return [3, 2];
                    payload = {
                        Question: question,
                        Answer: answer
                    };
                    return [4, api_service.post({
                            endPoint: api_urls.CREATE_FAQ,
                            payLoad: payload,
                            headerType: api_service.ContentHeaders.Json,
                            showLoader: true
                        })];
                case 1:
                    response = _c.sent();
                    if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        setOpenSuccessPopup(true);
                    }
                    return [3, 4];
                case 2:
                    if (!selectedFaq) return [3, 4];
                    payload = {
                        DocumentId: selectedFaq.id,
                        Question: question,
                        Answer: answer
                    };
                    return [4, api_service.put({
                            endPoint: api_urls.UPDATE_FAQ,
                            payLoad: payload,
                            headerType: api_service.ContentHeaders.Json,
                            showLoader: true
                        })];
                case 3:
                    response = _c.sent();
                    if (((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.statusCode) === 200) {
                        setOpenSuccessPopup(true);
                    }
                    _c.label = 4;
                case 4: return [3, 6];
                case 5:
                    error_2 = _c.sent();
                    return [3, 6];
                case 6: return [2];
            }
        });
    }); };
    var handleDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setOpenDeleteConfirmation(false);
                    if (!selectedFaq) return [3, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4, api_service.delete({
                            endPoint: "".concat(api_urls.DELETE_FAQ, "?DocumentId=").concat(selectedFaq.id),
                            showLoader: true
                        })];
                case 2:
                    response = _b.sent();
                    if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        handleCancel();
                    }
                    return [3, 4];
                case 3:
                    error_3 = _b.sent();
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var isFormVisible = isCreating || selectedFaq;
    return (React.createElement(Stack, { className: "chatbotWrapper", p: 2 },
        React.createElement(Stack, { direction: 'row', justifyContent: 'space-between' },
            React.createElement(Box, null,
                React.createElement(Typography, { fontSize: 20, fontWeight: 500 }, "Chatbot FAQ Management"),
                React.createElement(Typography, { variant: "body1" }, "Manage training data for the AI chatbot. Search existing FAQs or create new ones.")),
            React.createElement(Stack, { alignItems: 'center', justifyContent: 'center' },
                React.createElement(Typography, { fontSize: 20, fontWeight: 500 }, faqs === null || faqs === void 0 ? void 0 : faqs.length),
                React.createElement(Typography, { variant: "body1", fontSize: 12, textAlign: 'center' }, "Total FAQs"))),
        React.createElement(Divider, { sx: { width: '100%' } }),
        React.createElement(Stack, { className: 'searchWrapper' },
            React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", sx: { gap: 1, mb: 1, mt: 0, p: 0 } },
                React.createElement(Box, { sx: { width: '100%', '& .MuiFormControl-root': {
                            width: '100%',
                        } } },
                    React.createElement(TextField, { label: '', name: 'searchQuery', placeholder: 'Enter keywords to search...', value: searchQuery, onChange: handleSearchInputChange, type: "text", sx: { m: 0, p: 0, minHeight: 40, width: '100%' } })),
                canAdd && (React.createElement(Button, { component: "label", variant: "contained", startIcon: React.createElement(AddOutlinedIcon, null), onClick: handleCreateNew, sx: { whiteSpace: 'nowrap', minHeight: 40 } }, "Create New FAQ"))),
            !isFormVisible && (displayedFaqs.length === 0
                ? React.createElement(Typography, { className: "subTitle", variant: "body1", my: 6, textAlign: "center" }, "No FAQs found.")
                : React.createElement(Box, { sx: { maxHeight: 400, overflow: 'auto' } }, displayedFaqs.map(function (faq) { return (React.createElement(Card, { key: faq.id, className: 'faqCompactCard', sx: {
                        mb: 1,
                        p: 0,
                        boxShadow: 'none',
                        border: '1px solid #e0e0e0',
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'stretch',
                        minHeight: 48,
                        maxWidth: '85%'
                    } },
                    React.createElement(CardContent, { sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'stretch',
                            p: '8px 16px',
                            width: '100%',
                            '&:last-child': { p: '8px 16px' },
                            overflow: 'hidden'
                        } },
                        React.createElement(Stack, { direction: "row", alignItems: "center", sx: { width: '100%', mb: 0.5 } },
                            React.createElement(Tooltip, { title: faq.question, placement: "bottom-start", arrow: true },
                                React.createElement(Typography, { variant: "body2", fontWeight: 500, sx: {
                                        flex: 1,
                                        minWidth: 0,
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    } }, faq.question)),
                            canUpdate && (React.createElement(Box, null,
                                React.createElement(Button, { size: "small", onClick: function () { return handleEditFaq(faq); }, sx: { minWidth: 0, p: 0 } },
                                    React.createElement(EditOutlinedIcon, { fontSize: "small" }))))),
                        React.createElement(Tooltip, { title: faq.answer, placement: "bottom-end", arrow: true },
                            React.createElement(Typography, { variant: "body2", sx: {
                                    width: '90%',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    color: '#666',
                                    mb: 0.5
                                } }, faq.answer)),
                        React.createElement(Typography, { variant: "body1", fontSize: 10 },
                            "Last modified: ",
                            faq.updatedTime)))); })))),
        isFormVisible && (React.createElement(Stack, { className: 'searchWrapper' },
            React.createElement(Stack, { direction: 'row', alignItems: 'center', gap: 0.5 },
                isCreating ? React.createElement(AddOutlinedIcon, null) : React.createElement(EditOutlinedIcon, null),
                React.createElement(Typography, { variant: "body1", fontWeight: 500 }, isCreating ? 'Create New FAQ' : 'Edit FAQ')),
            React.createElement(Stack, { sx: { '& .MuiFormControl-root': { gap: 1 } } },
                React.createElement(TextField, { label: 'Question / Keywords', name: 'question', placeholder: 'Enter the question or keywords', fullWidth: true, value: question, onChange: function (e) {
                        var value = e.target.value;
                        var capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                        setQuestion(capitalizedValue);
                    }, type: "text", maxLength: 200 })),
            React.createElement(Stack, { gap: 1, sx: {
                    '& .textarea': {
                        p: '10px 12px',
                        resize: 'none',
                        borderRadius: '4px',
                        fontFamily: "'Nunito', sans-serif",
                        color: " #696F88",
                        '&::placeholder': {
                            fontSize: "14px",
                            color: "#c0c3cd"
                        },
                        '&:focus-visible': {
                            border: '2px solid #000000',
                            outline: 'none',
                            borderRadius: '4px'
                        },
                    }
                } },
                React.createElement(Typography, { variant: "body1", fontSize: 14 }, "ANSWER / RESPONSE"),
                React.createElement(CustomTextarea, { fieldName: 'answer', onChange: function (e) {
                        var value = e.target.value;
                        var capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                        setAnswer(capitalizedValue);
                    }, placeholder: 'ENTER THE ANSWER OR RESPONSE', rows: 7, value: answer, minrows: 7 })),
            React.createElement(Stack, { direction: 'row', gap: 2 },
                ((isCreating && canAdd) || (!isCreating && canUpdate)) && (React.createElement(Button, { variant: "contained", startIcon: React.createElement(SaveOutlinedIcon, null), onClick: handleSave, disabled: !question || !answer }, isCreating ? 'Create FAQ' : 'Save FAQ')),
                React.createElement(Button, { variant: "outlined", startIcon: React.createElement(CloseOutlinedIcon, null), onClick: function () { return setOpenCancelConfirmation(true); } }, "Cancel"),
                !isCreating && canDelete && (React.createElement(Button, { variant: "contained", color: "error", startIcon: React.createElement(DeleteOutlineOutlinedIcon, null), onClick: function () { return setOpenDeleteConfirmation(true); } }, "Delete FAQ"))))),
        React.createElement(ConfirmationAndInformationPoup, { open: openDeleteConfirmation, popupType: POPUP_TYPE.DELETE_CONFIRMATION_WARNING, titleText: "Are you sure?", message: "Are you sure you want to delete this FAQ?", acceptBtnText: "Yes", denyBtnText: "No", acceptCallBack: function () {
                if (selectedFaq === null || selectedFaq === void 0 ? void 0 : selectedFaq.id) {
                    handleDelete();
                }
            }, denyCallBack: function () {
                setOpenDeleteConfirmation(false);
            }, cancelCallBack: function () {
                setOpenDeleteConfirmation(false);
            } }),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.SUCCESS_ALERT, titleText: 'Success!', message: "FAQ has been ".concat(isCreating ? 'created' : 'updated', " successfully."), acceptBtnText: 'Ok', acceptCallBack: function () {
                setOpenSuccessPopup(false);
                handleCancel();
            }, open: openSuccessPopup, key: "".concat(openSuccessPopup) }),
        React.createElement(ConfirmationAndInformationPoup, { open: openCancelConfirmation, popupType: POPUP_TYPE.DELETE_CONFIRMATION_WARNING, titleText: "Discard Changes?", message: "Are you sure you want to cancel? All unsaved changes will be lost.", acceptBtnText: "Yes, Discard", denyBtnText: "No, Keep Editing", acceptCallBack: function () {
                setOpenCancelConfirmation(false);
                handleCancel(true);
            }, denyCallBack: function () {
                setOpenCancelConfirmation(false);
            }, cancelCallBack: function () {
                setOpenCancelConfirmation(false);
            } })));
};
export default ChatbotConfig;
